import React from "react";
import styled from "styled-components";
import { Text, breakpoints, colors, fontWeights } from "@trailhead/asurion-ui";

const Avatar = styled.img`
  display: block;
  position: relative;
  top: 0.375rem;
  left: 1rem;
  width: 2.25rem;
  height: 2.25rem;
  margin-top: -0.375rem;
  clip-path: circle(50%);

  ${breakpoints.lg} {
    width: 3.25rem;
    height: 3.25rem;
  }
`;

const MessageContainer = styled.div`
  display: inline-block;
  box-sizing: border-box;
  max-width: 10.125rem;
  padding: 0.75rem 0.5rem 0.5rem;
  border-radius: 0.625rem;
  background-color: ${colors.white};
  box-shadow: 0 0 0.75rem 0 rgba(${colors.black}, 0.1);

  ${breakpoints.lg} {
    max-width: 14.75rem;
    padding: 0.75rem 0.625rem 0.625rem;
    border-radius: 0.875rem;
    box-shadow: 0 0 1.125rem 0 rgba(${colors.black}, 0.1);
  }
`;

const Message = styled(Text)`
  display: block;
  font-weight: ${fontWeights.feather};
  font-size: 0.625rem;
  line-height: 1.3;

  ${breakpoints.lg} {
    font-size: 0.875rem;
  }
`;

interface Props {
  avatar: string;
  message: string;
  maxLine?: number;
}
export const ChatDemo = ({ avatar, message }: Props) => (
  <div>
    <Avatar src={avatar} alt="avatar" />
    <MessageContainer>
      <Message>{message}</Message>
    </MessageContainer>
  </div>
);
